import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PaginatedTable from "../../components-bootstrap/PaginatedTable";
import { BodyBuilder } from "../../../exports/Images";
import { selectAuth } from "../../auth/auth.selector";
import { fetchAllPTMembersData } from "../../../redux/reducers/apiSlice";
import SelectDropdown from "../../components-react/SelectDropdown";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";

const MultiRowSelectTable = ({
  initialSelectedRowDetails,
  selectedRowInfo,
  setSelectedRowInfo,
  setSelectedGym,
  queryParametersForAll,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const gymData = useSelector(selectGymData);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { ptMembersData } = useSelector((state) => state.api);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const initialPTMembers = {
    pageNo: 0,
    pagination: [],
    allPTMembers: [],
  };
  const [ptMemberDatas, setPTMemberDatas] = useState(initialPTMembers);

  const handleToggleAllClick = () => {
    if (isAllSelected) {
      setSelectedRowInfo(initialSelectedRowDetails);
    } else {
      const updatedDataValues = ptMemberDatas.allPTMembers?.map((item) => ({
        ...item,
        select: true,
      }));

      const selectedRowsArray = updatedDataValues?.map((item) => item.user_id);
      const selectedSubsIdArray = updatedDataValues?.map(
        (item) => item.subscription_id
      );
      const selectedTrainerIdsArray = updatedDataValues?.map(
        (item) => item.trainer_id
      );
      const selectedGymIdsArray = updatedDataValues?.map((item) => item.gym_id);

      setSelectedRowInfo({
        selectedRows: selectedRowsArray,
        selectedSubsId: selectedSubsIdArray,
        selectedTrainerIds: selectedTrainerIdsArray,
        selectedGymIds: selectedGymIdsArray,
      });
    }

    setIsAllSelected(!isAllSelected);
  };

  const handleCheckboxClick = (element, row) => {
    const userId = row?.user_id;
    const subsId = row?.subscription_id;
    const trainerId = row?.trainer_id;
    const gymId = row?.gym_id;

    setSelectedRowInfo((prevSelectedRowInfo) => ({
      selectedRows: element.checked
        ? [...prevSelectedRowInfo.selectedRows, userId]
        : prevSelectedRowInfo.selectedRows.filter(
            (selectedUserId) => selectedUserId !== userId
          ),
      selectedSubsId: element.checked
        ? [...prevSelectedRowInfo.selectedSubsId, subsId]
        : prevSelectedRowInfo.selectedSubsId.filter(
            (selectedSubsId) => selectedSubsId !== subsId
          ),
      selectedTrainerIds: element.checked
        ? [...prevSelectedRowInfo.selectedTrainerIds, trainerId]
        : prevSelectedRowInfo.selectedTrainerIds.filter(
            (selectedTrainerId) => selectedTrainerId !== trainerId
          ),
      selectedGymIds: element.checked
        ? [...prevSelectedRowInfo.selectedGymIds, gymId]
        : prevSelectedRowInfo.selectedGymIds.filter(
            (selectedGymId) => selectedGymId !== gymId
          ),
    }));
  };

  const handleCheckboxFocus = (element) => {
    const closestTr = element.closest("tr");
    if (closestTr) {
      closestTr.classList.add("focused");
    }
  };

  const handleCheckboxBlur = (element) => {
    const closestTr = element.closest("tr");
    if (closestTr) {
      closestTr.classList.remove("focused");
    }
  };

  const handleCheckboxKeyUp = (e, checkbox) => {
    if (e.which === 13) boxPressed(checkbox);
  };

  const boxPressed = (cbox) => {
    if (cbox.closest("select").matches(":focus")) return;

    if (cbox.closest("tr").classList.contains("row-selected")) {
      cbox.closest("tr").classList.remove("row-selected");
      cbox.checked = false;
      cbox.closest("label").classList.remove("selected");
    } else {
      cbox.closest("tr").classList.add("row-selected");
      cbox.checked = true;
      cbox.closest("label").classList.add("selected");
    }
  };

  useEffect(() => {
    dispatch(
      fetchAllPTMembersData({
        pageNo: ptMemberDatas.pageNo + 1,
        trainerId: "",
        queryParameters: queryParametersForAll || "",
        token: decryptedText?.token,
      })
    );
  }, [queryParametersForAll, ptMemberDatas.pageNo]);

  useEffect(() => {
    if (ptMembersData?.status && ptMembersData?.data?.length > 0) {
      setPTMemberDatas({
        ...ptMemberDatas,
        allPTMembers: ptMembersData.data,
        pagination: ptMembersData?.pagination,
      });
    } else {
      setPTMemberDatas(initialPTMembers);
    }
  }, [ptMembersData]);

  useEffect(() => {
    dispatch(fetchGymData(decryptedText?.token));
  }, [dispatch]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  const allPtMembers = [
    {
      dataField: "select",
      text: "Select",
      formatter: (cell, row) => (
        <div className="tbDataFlexCenter">
          <input
            type="checkbox"
            onFocus={(e) => handleCheckboxFocus(e.target)}
            onBlur={(e) => handleCheckboxBlur(e.target)}
            onClick={(e) => handleCheckboxClick(e.target, row)}
            onKeyUp={(e) => handleCheckboxKeyUp(e, e.target)}
            checked={selectedRowInfo.selectedRows?.includes(row?.user_id)}
            onChange={() => {}}
          />
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "N/A"}
            className="image"
            // onClick={() => {
            //   setViewImage(row?.profile || BodyBuilder);
            //   setImageModal(true);
            // }}
          />
          <p className="name" style={{ width: "auto" }}>
            {row?.member_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "member_mobile",
      text: "Number",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info email">{row?.member_mobile || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "member_email",
      text: "Email",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info email">{row?.member_email || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.gym_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.trainer_name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info violetBg"
            style={{
              background: "#E8E8FF",
              color: "#1E1E1E",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.plan_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "Plan Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "last_session",
      text: "Last Session",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.last_session || "-"}</p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "Session Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "N/A"}
          </p>
        </div>
      ),
    },
  ];

  return (
    <div className="campaignTableContainer ptFlowMultiselectTbContainer">
      <div className="lastFlex">
        <div
          className="filter"
          style={{
            border: "1px solid lightgray",
            borderRadius: "8px",
            width: "150px",
          }}
        >
          <SelectDropdown
            options={gymData}
            selectedOption={setSelectedGym}
            setSelectedOption={(selectedValue) => setSelectedGym(selectedValue)}
            name=""
          />
        </div>
        <button
          onClick={handleToggleAllClick}
          type="button"
          className={`selectunselectBtn ${
            isAllSelected ? "selected" : "notSelected"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-check2-square"
            viewBox="0 0 16 16"
          >
            <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5z" />
            <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0" />
          </svg>
          {isAllSelected ? "Unselect All" : "Select All"}
        </button>
      </div>

      <PaginatedTable
        columnsValues={allPtMembers}
        dataValues={ptMemberDatas.allPTMembers || []}
        paginationData={ptMemberDatas.pagination}
        isPage={ptMemberDatas.pageNo}
        setIsPage={(value) =>
          setPTMemberDatas((prevData) => ({
            ...prevData,
            pageNo: value,
          }))
        }
      />
    </div>
  );
};

export default MultiRowSelectTable;
